import type { PageTour } from '../types';

export const trainingTour: PageTour = {
  id: 'training',
  label: 'Training Tour',
  steps: [
    {
      target: '[data-tour="training-header"]',
      title: 'Training & Development',
      content: 'Access training modules, track your learning progress, and develop your skills from this page.',
    },
    {
      target: '[data-tour="training-tabs"]',
      title: 'Training Sections',
      content: 'Switch between your enrolled courses, the training library, and your personal development plan.',
    },
    {
      target: '[data-tour="training-content"]',
      title: 'Course Content',
      content: 'Browse available training modules. Each card shows the topic, duration, and your completion progress.',
    },
  ],
};
